import { render, staticRenderFns } from "./ReportRegist.vue?vue&type=template&id=72bf288d&"
import script from "./ReportRegist.vue?vue&type=script&lang=js&"
export * from "./ReportRegist.vue?vue&type=script&lang=js&"
import style0 from "./ReportRegist.vue?vue&type=style&index=0&id=72bf288d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports